import actionTypes from "./actionTypes";
import api from "./api";
export default {
    getVersionInfo: () => ({
        type: actionTypes.GET_VERSION_INFO,
        payload: {
            promise: () => api.getVersionInfo()
        }
    })
};
